import * as React from "react";
import {Grid} from "tabler-react";
import SiteWrapper from "../../SiteWrapper.react";
import {RecuperarGpsForm}  from "../../AgregarGps";

function RecuperarGpsPage() {
  return (
    <SiteWrapper>
        <Grid.Col sm={12} lg={12}> 
        < RecuperarGpsForm  />
        </Grid.Col>
    </SiteWrapper>
  );
}
export default RecuperarGpsPage;
